module.exports = __webpack_public_path__ + "media/sodrofa.b0b53521.webm";